import { EventEmitter } from "events";

import dispatcher from "../utils/dispatcher.js";
import * as Connection from "../utils/Connections";
import $ from "jquery";
class MyProfileStore extends EventEmitter {
    constructor() {
        super();
        this.profile={
            email:'',
            id:'',
            joined:'',
            location:'',
            name:'',
            phone:'',
            lastLogin:'',
            completed:'',
            pending:'',
            farmers:'',
            picture:''
        }



    }

    getProfileData(){
        return this.profile;
    }


    handleActions(action) {
        switch (action.type) {

            case "RECEIVE_MY_PROFILE_EDIT":
            {
                var profile=action.profile;
                this.profile.email=profile.email;
                this.profile.id=profile.id;
                this.profile.joined=profile.inserted_on;
                this.profile.name=profile.name;
                this.profile.location=profile.location;
                this.profile.phone=profile.phone;
                this.profile.lastLogin=profile.update_date;
                this.profile.completed=action.completed;
                this.profile.pending=action.pending;
                this.profile.farmers=action.farmers;
                this.profile.picture=profile.picture;
                this.emit("change");
                break
            }
            case "RECEIVE_PROFILE_UPDATE_SUCCESSFUL":{
                var info=action.residueData;
                this.profile.name=info.name;
                this.profile.email=info.email;
                this.profile.location=info.location;
                this.profile.phone=info.phone;
                if(info.password==""){
                    alert('Profile updated');
                }else{
                    alert('Password Updated');
                }
                this.emit("change");

                break;
            }

        }
    }

}

const myProfileStore = new MyProfileStore;
dispatcher.register(myProfileStore.handleActions.bind(myProfileStore));

export default myProfileStore;



// WEBPACK FOOTER //
// ./src/stores/MyProfileStore.js